import { useEffect } from 'react'

// https://github.com/childrentime/reactuse/blob/main/packages/core/hooks/useMount
export const useMount = (effect) => {
  // eslint-disable-next-line
  useEffect(effect, [])
}
